import React, { useEffect, useState } from "react";

const useDebounce = (
  value: string | number,
  delay: number,
  pageHandler?: any
) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (pageHandler) pageHandler();
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
